import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { ErrorBoundary } from 'react-error-boundary';
import { Theme } from '@radix-ui/themes';

import { WindowSizeContext } from 'contexts/WindowSizeContext';
import actions from 'redux/actions';
import { ToastContainer } from 'components/ui/Toast';
import PortalModalContainer from 'components/ModalContainer/PortalModalContainer/PortalModalContainer';
import { ModalProvider } from 'contexts/ModalContext';
import { useWindowSize } from 'hooks';
import ErrorBoundaryFallback from 'App/ErrorBoundaryFallback';
import { logError } from 'utils/errorHandling';
import reportWebVitals from 'utils/reportWebVitals';
import '@radix-ui/themes/styles.css';

ReactGA.initialize(process.env.NODE_ENV === 'production' ? 'G-0QW3XVG74P' : 'G-NL4D7RT1EV');

const App: React.FC = () => {
    useEffect(() => {
        actions.wsConnect();
        reportWebVitals((metric) => {
            console.log('WebVitals', metric);
        });
    }, []);

    const windowSize = useWindowSize();

    return (
        <ErrorBoundary
            fallbackRender={ErrorBoundaryFallback}
            onError={(error, info) => logError('App.tsx failed to render', error, info)}
        >
            {/* Provide window size / isMobile to all components to avoid creating multiple event listeners */}
            <WindowSizeContext.Provider value={windowSize}>
                <ModalProvider>
                    <Theme>
                        <Outlet />
                    </Theme>
                    <PortalModalContainer />
                    <ToastContainer />
                </ModalProvider>
            </WindowSizeContext.Provider>
        </ErrorBoundary>
    );
};

export default App;
